import React from 'react';

import { Severity } from '@ariksa/notification';
import { Box } from '@chakra-ui/react';

import { getIcon } from 'components/Icons/Components';
import { IconType } from 'components/Icons/types';
import { toTitleCase } from 'utils/string';

export function activeAssetsAlertUrl(resource_uuid, resource_type) {
  return `/alerts/active/assets?entity_uuid=${resource_uuid}&resource_type=${resource_type}`;
}

export const SeverityList = [
  Severity.Critical,
  Severity.High,
  Severity.Medium,
  Severity.Low,
];
export const SeverityListOptions = SeverityList.map(a => ({
  label: toTitleCase(a),
  value: a,
}));

export const alertStatusOptions = [
  { label: 'Open', value: 'Open' },
  { label: 'Resolved', value: 'Resolved' },
];

// Status reached only through ?alertStatus=Exception links. Kept out of the
// filter dropdown, but needed so the exception filter is applied.
export const exceptionAlertStatusOption = {
  label: 'Exception',
  value: 'Exception',
};

export const renderIcon = (type: IconType, color?: string) => (
  <Box w={4} color={color}>
    {getIcon(type)}
  </Box>
);
